<footer data-aos="fade-in" data-aos-duration="800" class="footer primary_background">
	<!-- Footer Top -->
	<div class="footer-top">
		<div class="container-fluid">
			<div class="row">
				<div class="col-lg-3 col-md-6">

					<!-- Footer Widget -->
					<div class="footer-widget footer-about">
						<div class="footer-logo">
							<img src="assets/img/navbar/whiteIHosLogo.png" alt="logo" loading="lazy">
						</div>
						<div class="footer-about-content">
							<p>{{ 'footer.aboutIhosp' | translate }} </p>
							<div class="social-icon">
								<ul>
									<li>
										<a href="https://web.facebook.com/iHospital.Jo" target="_blank"><i class="fa fa-facebook"></i>
										</a>
									</li>
									<!-- <li>
										<a href="javascript:void(0)" target="_blank"><i class="fab fa-twitter"></i> </a>
									</li> -->
									<li>
										<a href="https://www.linkedin.com/company/ihospital/" target="_blank"><i
												class="fa fa-linkedin"></i></a>
									</li>
									<li>
										<a href="https://www.instagram.com/ihospital.jo/" target="_blank"><i
												class="fa fa-instagram"></i></a>
									</li>
									<!-- <li>
										<a href="javascript:void(0)" target="_blank"><i class="fab fa-dribbble"></i>
										</a>
									</li> -->
								</ul>
							</div>
						</div>
					</div>
					<!-- /Footer Widget -->

				</div>

				<div class="col-lg-3 col-md-6">

					<!-- Footer Widget -->
					<div class="footer-widget footer-menu">
						<h2 class="footer-title">{{ 'footer.For Patients' | translate }}</h2>
						<ul>
							<li><a (click)="app?.mainRouteToSearchComponent()">{{ 'footer.Search for Doctors' | translate }}</a></li>
							<li><a *ngIf="!this.app.getUserData()" [routerLink]="'/' + app?.languageCode +'/login-page'">{{ 'footer.Login' | translate }}</a></li>
							<li *ngIf="this.app.getUserData()"><a (click)="app?.mainLogOut()" class="cursor-pointer">{{ 'Patient.Logout' | translate }}</a></li>
							<li><a [routerLink]="'/' + app?.languageCode +'/Register'">{{ 'footer.Register' | translate }}</a></li>
						</ul>
					</div>
					<!-- /Footer Widget -->

				</div>

				<div class="col-lg-3 col-md-6">

					<!-- Footer Widget -->
					<div class="footer-widget footer-menu">
						<h2 class="footer-title">{{ 'footer.For Doctors' | translate }}</h2>
						<ul>
							<!-- <li><a>{{ 'footer.Appointments' | translate }}</a></li> -->
							<!-- <li><a>{{ 'footer.Chat' | translate }}</a></li> -->
							<li *ngIf="!this.app.getUserData()"><a [routerLink]="'/' + app?.languageCode +'/login-page'">{{ 'footer.Login' | translate }}</a></li>
							<li *ngIf="this.app.getUserData()"><a (click)="app?.mainLogOut()" class="cursor-pointer">{{ 'Patient.Logout' | translate }}</a></li>
							<li *ngIf=" this?.app?.getUserData()?.applicationType==2 &&
                            this?.app.getUserData()?.hasPendingHcpRequest==false && this?.app?.getUserData() &&
                            this?.app?.isPatient ==true "><a [routerLink]="'/' + app?.languageCode +'/become-doctor'">{{
									"NavBar.becomeDoctor" | translate }}</a></li>
							<li *ngIf="!this?.app?.isDoctor"><a [routerLink]="'/' + app?.languageCode +'/Register'">{{
									"NavBar.becomeDoctor" | translate }}</a></li>
						</ul>
					</div>
					<!-- /Footer Widget -->

				</div>

				<div class="col-lg-3 col-md-6">

					<!-- Footer Widget -->
					<div class="footer-widget footer-contact">
						<h2 class="footer-title px-20">{{ 'footer.Contact Us' | translate }}</h2>
						<div class="footer-contact-info">
							<!-- <div class="footer-address">
								<span><i class="fa fa-map-marker-alt"></i></span>
								<p>{{ 'footer.iHospitalLocation' | translate }}</p>
							</div> -->
							<p>
								<i class="fa fa-phone"></i>
								{{ 'doctorProfile.iHosPhoneNumberAlone' | translate }}
							</p>
							<p class="mb-0">
								<i class="fa fa-envelope"></i>
								{{ 'footer.IHospitalEmail' | translate }}
							</p>
						</div>
					</div>
					<!-- /Footer Widget -->

				</div>

			</div>
		</div>
	</div>
	<!-- /Footer Top -->

	<!-- Footer Bottom -->
	<div class="footer-bottom">
		<div class="container-fluid">

			<!-- Copyright -->
			<div class="copyright">
				<div class="row">
					<div class="col-md-6 col-lg-6 col-12">
						<div class="copyright-text">
							<p  class="mb-0">© {{currentYear}} {{ 'footer.IhospitalAllRightsReserved' | translate }}</p>
							<!-- <p *ngIf="this.app?.getUserLanguage() == 'ar'" class="mb-0">© {{currentYear}} {{ 'footer.IhospitalAllRightsReserved' | translate }}</p> -->
						</div>
					</div>
					<div class="col-md-6 col-lg-6">

						<!-- Copyright Menu -->
						<div class="copyright-menu">
							<ul class="policy-menu res-last-line">
								<!-- href="https://www.ihospitalapp.com/terms-and-conditions.html" -->
								<li><a href="javascript:void(0);" [routerLink]="'/' + app?.languageCode +'/terms'">{{ 'footer.Terms and Conditions' | translate }}</a></li>
								<!-- href="https://www.ihospitalapp.com/privacy-policy.html" -->
								<li class="mr-15"><a href="javascript:void(0);" [routerLink]="'/' + app?.languageCode +'/terms'">{{ 'footer.Policy' | translate }}</a></li>
							</ul>
						</div>
						<!-- /Copyright Menu -->

					</div>
				</div>
			</div>
			<!-- /Copyright -->

		</div>
	</div>
	<!-- /Footer Bottom -->
</footer>